import { FILTER_TYPE } from '../../../constants';
import { ControlContainer } from './styled';
import CollapsibleCheck from '../../CollapsibleCheck';
import type {
  CustomCompanyFilter,
  RuleFunction,
} from '../../MoreFiltersConfig/filters';
import FilterControls from './FilterControls';
import RowCol from './RowCol';
import { parseRules } from '../../../functions';
import { rulesWithPercent } from '@/redux/grid/utils';

const parseRule = (rule: string | null) => {
  return typeof rule === 'string' ? parseRules(rule) : ['', '', 0, 100];
};

interface DynamicFilterProps {
  onChange: (id: string, rule: string) => void;
  onToggle: (id: string, rule?: string) => void;
  currentRule: string;
  toggled: boolean;
}

const DynamicFilter = (props: DynamicFilterProps & CustomCompanyFilter) => {
  const {
    subLabel,
    toggled,
    currentRule,
    defaultValue = '',
    id = '',
    label = '',
    labels = {},
    max = 100,
    min = 0,
    onChange = () => null,
    softMax = 0,
    softMin = 100,
    step = 1,
    rule = '',
    type = FILTER_TYPE.TOGGLE,
    titleFormatter = () => '',
    valueResolver = (_) => _,
    ruleToValue = (_) => [_[2], _[3]],
  } = props;

  const Control = FilterControls[type as string];
  const parsedRule = parseRule(
    currentRule !== undefined ? currentRule : defaultValue
  ) as (number | string)[];

  const rulesPercent = rulesWithPercent(parsedRule);
  const currentValue = ruleToValue ? ruleToValue(rulesPercent) : '';
  const formattedTitle = titleFormatter ? titleFormatter(rulesPercent) : '';
  return (
    <RowCol hideBorder={type === FILTER_TYPE.TOGGLE}>
      <CollapsibleCheck
        toggled={toggled}
        label={label}
        subLabel={subLabel}
        formattedTitle={formattedTitle}
        onToggle={handleToggle(props)}
        type={type}
      >
        <ControlContainer>
          {Control && (
            <Control
              defaultValue={defaultValue}
              id={id}
              labels={labels}
              max={max}
              min={min}
              onChange={onChange}
              softMax={softMax}
              softMin={softMin}
              step={step}
              valueResolver={valueResolver}
              rule={rule}
              currentValue={currentValue}
            />
          )}
        </ControlContainer>
      </CollapsibleCheck>
    </RowCol>
  );
};

function handleToggle(props: DynamicFilterProps & CustomCompanyFilter) {
  const {
    type,
    rule,
    toggled,
    untoggledRule,
    currentRule,
    defaultValue,
    onToggle,
    id,
  } = props;
  return function () {
    let resolvedRule = '';
    if (type === FILTER_TYPE.TOGGLE) {
      const canCallRuleResolver = typeof rule === 'function';
      if (rule && canCallRuleResolver) {
        resolvedRule = (rule as RuleFunction)(!toggled); // toggled hasn't been toggled yet
      } else if (untoggledRule && toggled) {
        resolvedRule = untoggledRule;
      } else {
        resolvedRule = currentRule || defaultValue;
      }
    } else {
      resolvedRule = currentRule !== undefined ? currentRule : defaultValue;
    }
    onToggle(id, resolvedRule);
  };
}

export default DynamicFilter;
